require("./brokerCustomWalletCreateView.scss");
//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
//commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @components
const { BrokerCustomWalletCreate } = require('../components/brokerCustomWalletCreate/brokerCustomWalletCreateContainer');
const { BrokerCustomWalletSideBar } = require('../components/brokerCustomWalletSideBar/brokerCustomWalletSideBarContainer');
//constants
const {
    BROKER_CUSTOM_WALLET_INVESTMENTS,
    BROKER_CUSTOM_WALLET_CONFIGURATION_URL
} = require('../constants/index');

class BrokerCustomWalletCreateView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //breadcrums definitions
        const mappingBreadcrumb = [
            {
                text: formatText("brokerCustomWallet-breadcrumbInvestments"),
                url: BROKER_CUSTOM_WALLET_INVESTMENTS
            },
            {
                text: formatText("brokerCustomWallet-breadcrumbConfiguration"),
                url: BROKER_CUSTOM_WALLET_CONFIGURATION_URL
            },
            {
                text: formatText("brokerCustomWallet-breadcrumbConfigureNewView")
            }
        ];

        const okHeader = (
            <div className="container-fluid">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle('brokerCustomWallet-createViewTitle')}>
                </OKHeaderSubPage>
            </div>
        );

        const content = (
            <React.Fragment>
                <div className="col-xs-8">
                    <BrokerCustomWalletCreate />
                </div>
                <div className="col-xs-4">
                    <BrokerCustomWalletSideBar />
                </div>
            </React.Fragment>
        );

        return (
            <div className="custom-wallet-create">
                <OKCover size="medium" section="cw">
                    {okHeader}
                </OKCover>
                <section className="custom-wallet-create__body">
                    {content}
                </section>
            </div>
        );
    }
}

BrokerCustomWalletCreateView.propTypes = {
    immBrokerCustomWalletCreate: PropTypes.any
};

module.exports.constructor = BrokerCustomWalletCreateView;
module.exports.BrokerCustomWalletCreateView = connect(
    state => ({
        immBrokerCustomWalletCreate: state.brokerCustomWalletCreate
    })
)(BrokerCustomWalletCreateView);
